/**
 * Created by lihanying on 2017/7/6.
 */

export const GETPAYMENTLIST = 'GETPAYMENTLIST'
export const GETBUSINESS = 'GETBUSINESS'
export const GETPERIOD = 'GETPERIOD'
export const GETRECORDDETAIL = 'GETRECORDDETAIL'
export const GETINCOMESUM = 'GETINCOMESUM'
export const CLUB_ID = 'club_id'
export const UPDATE_PURCHASE_SERVICES = 'UPDATE_PURCHASE_SERVICES'
export const GETBILLREMARKS = 'GETBILLREMARKS'
export const GETBILLREMARKSUM = 'GETBILLREMARKSUM'



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/constants.js